/* PauseQuestionRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class PauseQuestionRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("pause-resume-question-gl");
        this._rootElem.component = this._model;

        this.buttons = [];
        this.listeners = [];

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model._title;
        this._messageComponent = document.createElement("p");
        this._messageComponent.innerText = this._model._message;

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {}
    _unregisterListeners() {
        this.listeners.forEach((button) => button.removeAllListeners("UserClick"));
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        return Promise.all(this.buttons.map((button) => button.shutdown())).then(
            () => {
                this.buttons = undefined;
                this.listeners = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._messageComponent.remove();
                this._messageComponent = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "PauseQuestionRenderer.shutdown() error");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._messageComponent);
                this._renderActions(this._buttonContainer);
                this._rootElem.appendChild(this._buttonContainer);
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _renderActions(buttonsContainer) {
        const buttons = this._model._buttons;

        buttons.forEach((button) => {
            const Button = new ButtonControl({
                label: button.label,
                darkTheme: true
            });
            this.buttons.push(Button);
            this.listeners.push(Button.on("UserClick", () => this._callRunAction(button.action)));

            const buttonRoot = Button.renderer.rootElement;
            buttonRoot.classList.add(button.type || "");
            buttonsContainer.appendChild(buttonRoot);
        });
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _callRunAction(action) {
        this._model.confirmModal(action);
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = PauseQuestionRenderer;
